import { useState, useEffect, useMemo } from "react";
import { QUESTIONS } from "../../data/Questions";

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export default function Assessment({ onComplete, isSubmitting }) {
  const [current, setCurrent] = useState(0);

  // scroll to top on question change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [current]);

  const [answers, setAnswers] = useState(
    new Array(QUESTIONS.length).fill(null),
  );

  const q = QUESTIONS[current];

  // Shuffle options once per question (stable across re-renders of the same question)
  const shuffledOptions = useMemo(
    () => shuffle(QUESTIONS[current].options),
    [current],
  );

  function selectOption(opt) {
    const next = [...answers];
    next[current] = { v: opt.v, dim: q.dim };
    setAnswers(next);
  }

  function prev() {
    if (current > 0) setCurrent(current - 1);
  }

  function next() {
    if (current < QUESTIONS.length - 1) {
      setCurrent(current + 1);
    } else {
      onComplete(answers.filter(Boolean));
    }
  }

  const selected = answers[current];
  const isLast = current === QUESTIONS.length - 1;

  return (
    <div className="assessment">
      <div className="progress-meta">
        <span className="progress-label">Flow Identity Assessment</span>
        <span className="progress-count">
          {current + 1} of {QUESTIONS.length}
        </span>
      </div>
      <div className="progress-track">
        <div
          className="progress-fill"
          style={{ width: `${((current + 1) / QUESTIONS.length) * 100}%` }}
        />
      </div>
      <p className="q-scenario">{q.scenario}</p>
      <p className="q-prompt">{q.prompt}</p>
      <div className="options">
        {shuffledOptions.map((opt) => (
          <button
            key={opt.v}
            className={`option${selected && selected.v === opt.v ? " selected" : ""}`}
            onClick={() => selectOption(opt)}
          >
            {opt.t}
          </button>
        ))}
      </div>
      <div className="nav-buttons">
        <button className="btn-prev" onClick={prev} disabled={current === 0}>
          ← Back
        </button>
        <button
          className="btn-next"
          onClick={next}
          disabled={!selected || isSubmitting}
        >
          {isSubmitting
            ? "Saving your results..."
            : isLast
              ? "See where you are →"
              : "Continue →"}
        </button>
      </div>
    </div>
  );
}
